"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Checkbox_meta_1 = require("../Checkbox.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('label', Checkbox_meta_1.CHECKBOX_CATEGORY_KEY, Checkbox_meta_1.CHECKBOX_COMPONENT_KEY, ['label']);